import Standalone from "./Standalone"
export const Support = (): React.ReactElement => {

	return <Standalone>
		<div style={{paddingLeft: '10px', paddingRight: '10px'}}>
			{'Add me on discord @xpewster for any requests or bug reports. I don\'t bite! =)'}
		</div>
	</Standalone>;
}

export default Support;
